import { jsonToQueryString } from 'utils/functions'
import ApiService from './ApiService'

export async function apiSignIn(data, query) {
    return ApiService.fetchData({
        url: `?${jsonToQueryString({ action: 'login', ...query })}`,
        method: 'get',
    })
}

export async function apiSignUp(data) {
    return ApiService.fetchData({
        url: '/sign-up',
        method: 'post',
        data,
    })
}

export async function apiSignOut(data) {
    return ApiService.fetchData({
        url: '/sign-out',
        method: 'post',
        data,
    })
}

export async function apiForgotPassword(data) {
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data,
    })
}

export async function apiResetPassword(data) {
    return ApiService.fetchData({
        url: '/reset-password',
        method: 'post',
        data,
    })
}
